var SpriteSymbol = require("../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "sun",
  "use": "sun-usage",
  "viewBox": "0 0 68 69",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 68 69\" id=\"sun\"><path fill-rule=\"evenodd\" d=\"M48.4 3.6h19V0h-19zM0 3.6h19V0H0zm46.5 7 20.9 12.7v-4.6L48 7.1zM0 18.7v4.6l20.9-12.7-1.5-3.5zm40.6-2.4 26.8 47.3v-8.2L43.799 14.1zM0 55.4v8.2l26.8-47.3-3.2-2.2zm31.7 13.1h4.001V18H31.7z\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol